<app-header></app-header>
<div class="other-Page container">
    <h3>Terms and Conditions</h3>

    <p>Gamez Klub is an all you can eat subscription to an adult game service whereby a subscribed consumer can access
        and
        stream as many games as they like at the set fee. By making use of this service you acknowledge that you have
        read,
        understood and accepted these Terms and Conditions. By subscribing to the Gamez Klub subscription users will get
        unlimited access to the game contents thereof. The cost of the service is either 1 Day Free Trial or KES 10.00
        per
        day
        recurring and will be charged to your bill (postpaid users) or your prepaid balance (prepaid and hybrid users).
    </p>
    <h4>Services</h4>
    <p>Through the Gamez Klub service, Safaricom provides users with access to games service and content related to this
        content made available by its service providers or by third party users of the service and / or third-party
        service
        providers and content (hereinafter, the “Gamez Klub”). The service and its content is intended for Safaricom
        subscribers
        for any age groups. The service will be activated only at the time when the user requests it. You can register
        for
        the
        service by clicking the “SUBSCRIBE” (or its equivalent) button on the Gamez Klub portal detail page but only if
        i)
        your
        SIM is not registered as age restricted ii.) you are over the age of 18 years. Safaricom reserves the right to
        modify or
        remove the content provided as part of the service at any time without notice.</p>

    <h4>Costs and Payment</h4>
    <p>The subscription service cost for Gamez Klub is 1 Day Free Trial and KES 10 per day, (VAT included). Whichever
        subscription you opt for shall grant you unlimited access to stream the games within the Gamez Klub game
        catalogue
        for
        the period of the subscription you have chosen. The subscription costs will be charged to your bill (post-paid
        users) or
        to your existing balance Prepaid (prepaid users) and at the price indicated on the Gamez Klub portal. There will
        be
        no
        refunds for partial use of the service. This service does not use data for browsing, however, normal network
        data
        rates
        will apply for games.</p>

    <h4>Duration and Termination of Service</h4>
    <p>The service will remain active, unless otherwise specified by the User, who may unsubscribe at any time by: Going
        to
        the
        “My Account” section that can be found in the menu within Safaricom live! Once in “My Account” click on My
        Subscriptions, find your subscription to Gamez Klub and simply click the “Cancel” option. Your subscription will
        then be
        deactivated. Safaricom reserves the right to cancel your subscription at any time. The provision of the Gamez
        Klub
        portal and other services is, in principle, indefinite. Safaricom, however, is authorized to terminate or
        suspend
        provision of the Gamez Klub service and / or any of the Services at any time. When reasonably possible, prior
        notice
        of
        the termination or suspension of the service will be given.</p>

    <h4>Conditions of use of Contents</h4>
    <p>The Content(s) that you acquire and the corresponding related rights are valuable intellectual property of their
        respective owners and may be used only on your cell phone in which they have been offered either as a musical
        tone,
        screen saver, game, wallpaper or game to play solely on your cell phones and personal effects. It is strictly
        forbidden
        to transmit such Content from your cell phone, regardless of the means or purpose of the transmission. Also,
        copying,
        redistribution or other use of the content to that for which it has been offered is expressly prohibited. The
        content
        offered as part of the service, at any time, is done as an offer or sale via an online channel. Due to the
        different
        features and technical capabilities of various devices used to access the service, games viewed whilst using the
        service
        may vary depending on the device being used as well as the internet connection being used. * Henceforth the word
        content
        refers to the services that the user can play to their own phone and are published on the Gamez Klub or
        Safaricom
        live
        portal. The User shall abstain from obtaining or attempting to obtain information, messages, graphics, pictures,
        sound
        files and / or images, photographs, recordings, software and generally any kind of material accessible through
        Gamez
        Klub or Services (hereinafter, the Content) using means or other than that, depending on the case, that has been
        made
        available for this purpose or procedures that have been indicated to this effect on web pages where the Contents
        are
        or,
        in general, those normally used on the Internet for this purpose provided they do not pose a risk of damage or
        disable
        the Gamez Klub Portal, Services and / or Content. The User agrees to use the Content in good faith, diligently,
        correctly and legally and, in particular, undertakes to refrain from (A) using the Content for purposes or
        effects
        contrary to law, morals and good customs generally accepted, especially online behaviour standards or public
        order;
        (B)
        reproduce or copy, distribute, allow public access through any means of public communication, transform or
        modify
        the
        Content, unless you have obtained the authorization of the corresponding rights or it is legally permitted; (C)
        remove,
        ignore or manipulate the copyright and other data identifying the rights of Mus-ren, Safaricom or its content
        providers
        included in the content; (D) Use the contents and, in particular, information of any kind obtained through the
        Gamez
        Klub Portal Services to send advertising, communications for direct marketing purposes or any other commercial
        purpose,
        unsolicited messages addressed a plurality of people regardless of their purpose, and to refrain from selling or
        otherwise disclose such information; (E) generally violate in any way the rights of intellectual property and /
        or
        industrial Mus-ren and third parties whose contents are found staying in the Gamez Klub Portal.</p>

    <h4>Privacy</h4>
    <p>We will collect your mobile number and usage 2022; the personal information) to be able to provide the Service.
        We
        will
        share and make worldwide transfers of your personal information on our corporate systems, to other entities,
        agents,
        subcontractors in the Safaricom/Safaricom group companies or other relevant business partners involved in
        assisting
        us
        to provide this Service to you (i.e. Mus-ren). When sharing and making such transfers we will ensure that the
        necessary
        protections are in place to safeguard your personal information transfer and sharing under or in connection with
        these
        Terms of Service and our Privacy Policy (Hyperlink for Privacy Policy to be included -
        <a href="http://www.safaricom.co.ke/safaricom/terms/privacy-policy"
            target="_blank">http://www.safaricom.co.ke/safaricom/terms/privacy-policy</a>). We will store your personal
        information for as long as we
        are legally required to. If there is no legal requirement, we will only store the collected information for as
        long
        as
        we need it.
    </p>

    <h4>Use of the Gamez Klub Services and Content is The Sole Responsibility of the User</h4>
    <p>The User is aware and voluntarily accepts that the use of Gamez Klub Services and the Content therein is at the
        User
        2022; sole and exclusive responsibility.</p>

    <h4>Exclusion of Warranties and Liability</h4>
    <p>Safaricom has appointed Mus-ren to assist in delivering this Service. Safaricom and Mus-ren do not guarantee the
        legality, reliability and usefulness of the Content. Safaricom and Mus-ren are not liable for damages of any
        kind
        arising from the transmission, dissemination, storage, availability, reception, obtaining or access to the
        content,
        including, but not exclusively, for damages and losses arising from: (A) The breach of the law, morals and good
        manners
        generally accepted, especially the rules of behaviour in internet or public order as a result of the
        transmission,
        dissemination, storage, availability, reception, obtaining or access to the content; (B) The infringement of
        intellectual and industrial property, the secrets business commitments contractual of any kind of rights to
        honor to
        privacy personal and family and the image of the people of property rights and all other nature belonging to a
        third
        party as a result of the transmission, dissemination, storage, availability, reception, obtaining or access to
        the
        contents; (C) The performance of acts of unfair competition and illegal advertising as a result of the
        transmission,
        dissemination, storage, availability, reception, obtaining or access to the contents; (D) The lack of truth,
        accuracy,
        completeness, relevance and / or currency of the contents; (E) Any inadequacies or low expectations generated by
        the
        contents; (F) The breach, delay in compliance, defective or termination for any reason of the obligations
        contracted
        by
        third parties and contracts made with third parties through or with access to the contents; (G) The defects of
        any
        kind
        of the contents transmitted, disseminated, stored, made available or otherwise transmitted or made available,
        received,
        obtained or accessed through THE Portal or services. 5.2. Exclusion of guarantees and liability for the use of
        the
        PORTAL, Services and Content by Users. Safaricom and Mus-ren do not have an obligation and do not control the
        use of
        the
        Website, Services and contents by subscribers of the service. In particular, Safaricom and Mus-ren do not
        guarantee
        that
        users use the Gamez Klub Portal, Services and Content in accordance with these Terms and Conditions or do so in
        a
        diligent and prudent manner. Safaricom and Mus-ren have no obligation to check and verify the identity of users
        or
        the
        accuracy, validity, completeness. Safaricom and Mus-ren are not liable for damages of any kind arising from the
        use
        of
        the Service and content by users. (H) unauthorized use of trademarks or other intellectual property rights by or
        on
        linked sites. (I) any references made on this page to any product, service, process, linked site, hypertext or
        any
        other
        information on which brands and/or domains signs, trade names or names used in manufacturing, supplier, etc.
        that
        are
        owned by others, at no time constitute or imply endorsement or recommendation by Safaricom and Mus-ren, their
        subsidiaries and/or affiliates and in no case is Mus-ren, their subsidiaries and/or affiliates own or are
        responsible
        for them. Disclaimer Safaricom its subsidiaries and/or affiliates, inform Users of the Gamez Klub Portal, that
        there
        may
        be available technical link devices (such as, among others, links, banners, buttons), directories and search
        tools
        that
        allow them to access web pages belonging to third parties (hereinafter the & linked sites). The installation of
        these
        links on the Gamez Klub portal is limited to facilitate users to search for and access information available
        from
        the
        linked sites on the Internet, and does not presuppose any kind of link or association between Safaricom,
        Mus-ren,
        their
        subsidiaries and/or affiliates, and operators of the linked sites. Safaricom and Mus-ren, their subsidiaries
        and/or
        affiliates do not control, approve nor do the services, information, data, files, products and any kind of
        material
        on
        linked sites themselves. The user therefore should exercise caution in evaluating and using the services,
        information,
        data, files, products and any kind of material on linked sites. Safaricom and Mus-ren, their subsidiaries and /
        or
        affiliates do not warrant or assume any responsibility for damages of any kind that may be caused by: A) The
        operation,
        availability, accessibility or continuity of the linked sites. B) The maintenance of services, information,
        data,
        files,
        products and any kind of material on linked sites. C) The obligations and existing offers on the linked sites.
        By
        using
        these linked sites, you acknowledge and agree that Safaricom and Mus-ren, their subsidiaries and/or affiliates
        do
        not
        guarantee that the linked sites or information provided by third parties, are useful for the conduct of any
        particular
        activity. By using the linked sites, you acknowledge and agree that Safaricom and Mus-ren, its subsidiaries
        and/or
        affiliates are excluded from any liability for damages that may be caused by the accuracy of the information or
        quality
        of services contained or offered by third parties or that of the linked sites, or arising in connection to the
        Gamez
        Klub Portal, both access to this page and the use made of the information contained therein are the sole
        responsibility
        of the user.</p>
</div>


<app-footer></app-footer>